import { getPointCircleLayerConfig } from "@l2r-front/l2r-map"

import { I18N_NAMESPACE } from "../../../common/constants/i18n"

export const riskZonesLegend = [
    {
        minOperand: "<=",
        minValue: 0,
        maxOperand: ">=",
        maxValue: 2.5,
        color: "DPE/rouge",
        label: "containers.riskZonesLayer.legend.scale.veryHigh",
    },
    {
        minOperand: "<",
        minValue: 2.5,
        maxValue: 5,
        maxOperand: ">=",
        color: "DPE/orange",
        label: "containers.riskZonesLayer.legend.scale.high",
    },
    {
        minValue: 5,
        maxValue: 7.5,
        maxOperand: ">=",
        color: "DPE/jaune",
        label: "containers.riskZonesLayer.legend.scale.medium",
    },
    {
        minValue: 7.5,
        maxValue: 10,
        color: "DPE/vert-foncé",
        label: "containers.riskZonesLayer.legend.scale.low",
    },
]

export const getRiskZonesLegendConfig = (t, theme) => {
    return riskZonesLegend.map(legendItem => {
        return {
            color: theme?.palette?.[legendItem.color]?.main,
            label: t(I18N_NAMESPACE, legendItem.label),
        }
    })
        .reverse()
}

const MIN_ZOOM = 15
const MAX_ZOOM = 22
const MIN_RADIUS = 15
const MAX_RADIUS = 1600

function getInterpolatedCircleRadius() {
    return ["interpolate",
        ["exponential", 2],
        ["zoom"],
        MIN_ZOOM,
        MIN_RADIUS,
        MAX_ZOOM,
        MAX_RADIUS,
    ]
}

const CIRCLE_OPACITY_FADED = 0.4
const CIRCLE_OPACITY_DEFAULT = 0.8

export function getInterpolatedRadius(zoom) {
    const t = (zoom - MIN_ZOOM) / (MAX_ZOOM - MIN_ZOOM)
    const radius = MIN_RADIUS * Math.pow(2, t * Math.log2(MAX_RADIUS / MIN_RADIUS))
    return radius
}

export function shiftVertically(map, lngLat, pixelOffsetY = 0) {
    const point = map.project(lngLat)
    point.y += pixelOffsetY
    const newLngLat = map.unproject(point)
    return [newLngLat.lng, newLngLat.lat]
}

export const getRiskZonesLayerStyle = (theme, selectedRoad = null, currentYear = null, riskZoneId = null) => {
    const legendStyles = [
        ["==", ["get", "grade"], 0],
        theme.palette[riskZonesLegend[0].color].main,
    ].concat(riskZonesLegend.flatMap((legendItem) => {
        const color = theme.palette[legendItem.color].main
        return [
            ["all", [legendItem.minOperand ?? "<", legendItem.minValue, ["get", "grade"]], [legendItem.maxOperand ?? ">=", legendItem.maxValue, ["get", "grade"]]],
            color,
        ]
    }))
    const defaultColor = theme.palette[riskZonesLegend[riskZonesLegend.length - 1].color].main
    legendStyles.push(defaultColor)
    const yearFilter = ["==", ["get", "year", ["properties"]], parseInt(currentYear)]
    const notSelectedOpacity = riskZoneId ? [["!=", ["get", "riskZoneIdentifier", ["properties"]], parseInt(riskZoneId)], CIRCLE_OPACITY_FADED] : []
    return getPointCircleLayerConfig({
        "paint": {
            "circle-color":
                [
                    "case",
                    ...legendStyles,
                ],
            "circle-radius": getInterpolatedCircleRadius(),
            "circle-opacity": ["case",
                ...notSelectedOpacity,
                ["!=", ["typeof", selectedRoad], "string"],
                CIRCLE_OPACITY_DEFAULT,
                ["==", ["get", "road", ["at", 0, ["get", "linearLocation"]]], selectedRoad],
                CIRCLE_OPACITY_DEFAULT,
                CIRCLE_OPACITY_FADED,
            ],
        },
    }, yearFilter)
}
